class ScoreAnalysisCtrl
  constructor: (@$scope) ->
    @scoreData =
      rat_under_eagle: 0
      rat_birdie: 0
      rat_par: 0
      rat_bogey: 0
      rat_dbogey: 0
      rat_over_tbogey: 0

    @$scope.$on "myAnalysisUpdated.gnp.analysis", (event, myAnalysis) =>
      @scoreData = myAnalysis.my_avg

ScoreAnalysisCtrl.$inject = [
  '$scope'
]
module.exports = ScoreAnalysisCtrl




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/score-analysis/score-analysis-controller.coffee